import useCurrency from '../../../Components/Hooks/useCurrency';

// Thin wrapper kept so reporting components don't need to change their import.
// New code should import useCurrency directly.
const useReportFormat = () => {
  const { format } = useCurrency();
  return format;
};

export default useReportFormat;
